<template>
  <div id="app" @click="isTimeOut">
    <router-view v-if="isRouteralive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouteralive: true,
      lastTime: null,
      //30分钟未检测到鼠标点击
      timeOut: 30 * 1000 * 60,
    };
  },
  mounted() {
    const title = this.$getCfg("title");
    if (title && title.length > 0) {
      document.title = title;
    }
  },
  created() {
    this.lastTime = new Date().getTime();
  },
  methods: {
    //全局监听得点击事件
    isTimeOut() {
      let _this = this;
      var pathname = window.location.href; // 获取当前页面的路径和文件名，如/example/pathname.html
      if (pathname.includes("login")) {
        return false;
      }
      var currentTime = new Date().getTime();
      // 判断上次最后一次点击的时间和这次点击的时间间隔
      if (currentTime - _this.lastTime > _this.timeOut) {
        this.$alert("由于您长时间未操作，系统已自动退出，请重新登录", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
            _this.LogOut();
          },
        });
      } else {
        // 如果在期限内点击，则把这次点击的时间覆盖掉之前存的最后一次点击的时间
        this.lastTime = new Date().getTime();
      }
    },
    LogOut() {
      this.$store
        .dispatch("LogOut")
        .then(() => {
          // 清除自动登录信息
          var loginAutoFromLocalStorage = localStorage.getItem("loginAuto");
          if (loginAutoFromLocalStorage) {
            localStorage.removeItem("loginAuto");
            localStorage.removeItem("userinfo");
          }
          location.reload();
        })
        .catch(() => {
          location.reload();
        });
    },
    againLogin(loginForm) {
      let _this = this;
      this.$store
        .dispatch("Login", loginForm)
        .then((response) => {
          if (response.code == 50001) {
            _this.LogOut();
          } else {
            _this.LogOut();
            sessionStorage.setItem("pwd", JSON.stringify(loginForm));
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  reload() {
    this.isRouteralive = false;
    this.$nextTick(function () {
      this.isRouteralive = true;
    });
  },
};
</script>
<style rel="stylesheet/scss" lang="scss"></style>
